var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: "Lịch sử sử dụng gói giới hạn",
        width: "820px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _vm.schoolRow
        ? _c("div", { staticClass: "ps-history-header" }, [
            _c("div", [
              _c("span", { staticClass: "ps-history-header__eyebrow" }, [
                _vm._v("Lịch sử áp dụng gói"),
              ]),
              _c("h3", [_vm._v(_vm._s(_vm.schoolRow.school.name))]),
              _c("p", [
                _vm._v(
                  "Trường " +
                    _vm._s(_vm.schoolRow.school.id) +
                    " · " +
                    _vm._s(_vm.histories.length) +
                    " lần áp dụng"
                ),
              ]),
            ]),
            _c("div", { staticClass: "ps-history-total" }, [
              _c("span", [_vm._v("Gói hiện tại")]),
              _c("strong", [_vm._v(_vm._s(_vm.currentPackageCode))]),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "sk-table ps-table ps-history-table",
          attrs: {
            data: _vm.histories,
            border: "",
            size: "small",
            "empty-text": "Chưa có lịch sử sử dụng gói",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "Gói áp dụng", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "ps-package-code" }, [
                      _vm._v(_vm._s(row.packageCode || "—")),
                    ]),
                    _c("span", { staticClass: "ps-package-cell__base" }, [
                      _vm._v(_vm._s(row.packageName || "Không xác định")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Ngày áp dụng", width: "145", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDate")(row.assignedAt)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Ngày kết thúc", width: "145", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.endedAt
                      ? _c("span", [
                          _vm._v(_vm._s(_vm._f("formatDate")(row.endedAt))),
                        ])
                      : _c("span", { staticClass: "ps-row-muted" }, [
                          _vm._v("Đang sử dụng"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Giới hạn", width: "105", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatNumber")(row.effectiveLimit)) +
                        " HS\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Số lượng thêm", width: "115", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "ps-addon-amount" }, [
                      _vm._v(
                        "+" + _vm._s(_vm._f("formatNumber")(row.addonTotal))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Trạng thái", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.statusType(row),
                          size: "mini",
                          effect: "light",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.statusLabel(row)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Đóng")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }